import React from 'react';
import {Layout, Divider, Tree, Menu} from 'antd';
import {UserContext} from "@web/hooks/context";
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation} from 'wouter';
import PropTypes from "prop-types";
import voiceActions from "@web/redux/voice/actions";
import appActions from "@web/redux/app/actions";
// import {
//   AccountIcon,
//   // AddDocumentIcon,
//   // AddItemIcon,
//   // ApplicationIcon,
//   // AppstoreIcon, ClockIcon,
//   // AtOutlineIcon,
//   // BookIcon,
//   // BriefcaseIcon,
//   // CaptureIcon,
//   // ContactsOutlinedIcon,
//   DatabaseIcon, DatabasePlusIcon,
//   // DatasetIcon,
//   // DocumentIcon,
//   FeatherIcon,
//   // HomeOutlined,
//   // InboxIcon,
//   LeftArrowOutlined,
//   // LinkOutlined,
//   ListIcon, MenuIcon,
//   // MenuIcon,
//   // MessageOutlined,
//   // PhoneCallIcon,
//   // PinIcon,
//   PinIconFilled,
//   // PlusCircle,
//   // SettingsIcon,
//   // SlidesIcon,
//   // StarIcon,
//   // SubmenuIcon,
//   // TelegramIcon,
//   // TerminalIcon,
//   // TodoIcon,
//   // UserTodoIcon,
//   // WebsiteIcon,
// } from '@web/assets/icons';
// import LaunchSourceManagerButton from "./LaunchSourceManagerButton";
// import Icon from './Icon';
// import uniq from 'lodash/uniq';
// import collectionsActions from '@web/redux/collections/actions';
// import IconBadge from './IconBadge';
// import MenuButton from './MenuButton';
// import now from 'lodash/now.js';
// import {setPath} from '@web/lib/firestore.db';
// import collectionActions from "@web/redux/collections/actions";
// import {api} from '@web/lib/api';
import CollectionsTree from './CollectionsTree';
import {AccountIcon, DatabaseIcon, DatabasePlusIcon, FeatherIcon, ListIcon, PinIconFilled} from '@web/assets/icons';
import uniq from 'lodash/uniq';
// import IconBadge from './IconBadge';

DashboardMenu.propTypes = {
  right: PropTypes.node,
  isMobile: PropTypes.bool,
};

function DashboardMenu(props) {
  const dispatch = useDispatch();
  // const [userId, h, u, claims] = React.useContext(UserContext);
  const registering = useSelector((state) => state.Voice.registering);
  const registered = useSelector((state) => state.Voice.registered);
  const collapseMenu = useSelector((state) => state.App.collapseMenu);
  const menuWidth = useSelector((state) => state.App.menuWidth);
  const menuCollapsedWidth = useSelector((state) => state.App.menuCollapsedWidth);
  const collectionsLoaded = useSelector((state) => !!state.Collections.collections);
  const [location, setLocation] = useLocation();
  const [current, setCurrent] = React.useState(location);
  const pinnedItems = [];
  // const [collectionsList, setCollectionsList] = React.useState([]);

  React.useEffect(() => {
    if (registered || registering) return;
    dispatch(voiceActions.register());
  }, []);

  // React.useEffect(() => {
  //   collectionsLoaded &&
  //
  // }, [collectionsLoaded])

  React.useEffect(() => {
    setCurrent(location);
  }, [location]);

  const onCollapse = (collapsed, type) => {
    dispatch(appActions.toggleMenu(collapsed));
  }

  // const items = [];
  const bottomItems = [
    {type: "divider"},
    {
      label: 'Setup',
      key: '/start',
      icon: <FeatherIcon size={20} style={{position: "relative", top: 3}} />,
    },
    {type: "divider"},
    {
      label: 'Account',
      key: '/account',
      icon: <AccountIcon style={{position: "relative", top: 6}} />,
    },
  ];
  // user &&
  // items.push({
  //   label: "Home",
  //   icon: <MessageOutlined size={20} style={{position: "relative", top: 5}} />,
  //   // label: <NavigationLabel text="Chat" active={location.startsWith("/pro")} />,
  //   key: '/home',
  // });
  // claims?.data?.subs?.includes("email") &&
  // items.push({
  //   label: 'Calls',
  //     key: `/calls`,
  //   icon: <PhoneCallIcon style={{position: "relative", top: 4}} />,
  // },
  // );
  // items.push(
    // {type: "divider"},
    // {
    //   label: 'Timeline',
    //   key: `/timeline`,
    //   icon: <InboxIcon style={{position: "relative", top: 4}} />,
    // },
    // {type: "divider"},
    // claims?.data?.subs?.includes("creator") && {
    //   label: 'Apps',
    //   key: 'apps',
    //   icon: <AppstoreIcon style={{position: "relative", top: 5}} />,
    //   children: [
    //     { label: 'Store', key: '/app-store' },
    //     { label: 'Installed', key: '/apps' },
    //     { label: 'Create', key: '/apps/create' },
    //   ],
    // },
  // );
  const pinned = {
    label: "Pinned",
    key: "/",
    icon: <PinIconFilled style={{position: "relative", top: 5}} />,
    children: [
      ...uniq(pinnedItems || [])?.map?.((collectionId) => {
        return {
          label: collectionId.replace(/-/g, " "),
          key: collectionId,
          icon: <DatabaseIcon style={{position: "relative", top: 5}} />,
        };
      }),
    ],
  };
  const collections = {
    label: "Collections",
    key: "/",
    icon: <ListIcon style={{position: "relative", top: 5}} className="green-icon" />,
  };
  // const addList = {
  //   label: "new",
  //   key: "/new-list",
  //   icon: <DatabasePlusIcon style={{position: "relative", top: 5}} />,
  // };
  // const baseScheduler = {
  //   label: "Schedulers",
  //   key: "/schedulers",
  //   icon: <ClockIcon style={{position: "relative", top: 5}} />,
  //   children: [
  //     {
  //       label: "five minutes",
  //       key: "/schedulers/minutes",
  //       icon: <ClockIcon style={{position: "relative", top: 5}} />,
  //     },
  //     {
  //       label: "hourly",
  //       key: "/schedulers/hourly",
  //       icon: <ClockIcon style={{position: "relative", top: 5}} />,
  //     },
  //     {
  //       label: "daily",
  //       key: "/schedulers/daily",
  //       icon: <ClockIcon style={{position: "relative", top: 5}} />,
  //     },
  //   ]
  // }
  // React.useEffect(() => {
  //   api.v2({
  //     path: `${h}/collections`,
  //     method: "GET",
  //   })
  //   .then((result) => {
  //     setCollectionsList(
  //       Object.values(
  //         result
  //         .data
  //         .items
  //         .reduce(($acc, c) => {
  //           if (c.listed === false)
  //             return $acc;
  //
  //           c.menuGroup ?
  //             $acc[c.menuGroup] = {
  //               ...$acc[c.menuGroup] || {
  //                 title: c.menuGroup,
  //                 key: c.menuGroup,
  //               },
  //               children: [
  //                 ...$acc[c.menuGroup]?.children || [], {
  //                 title: c.collectionId,
  //                 label: c.collectionId,
  //                 key: "/" + c.objectID,
  //               }],
  //             } :
  //           $acc[c.collectionId] = {
  //             ...$acc[c.collectionId] || null,
  //             title: c.collectionId,
  //             label: c.collectionId,
  //             key: "/" + c.objectID,
  //           };
  //           return $acc;
  //         }, {}))
  //     )
  //   });
  // }, [userId]);
  const onClick = ({key, keyPath}) => {
    // const path = keyPath.reverse().join("");
    // console.log("onClick:", key, keyPath);
    // dispatch(collectionsActions.)
    setLocation(key);
    setCurrent(key);
  }

  return <Layout.Sider
    breakpoint="md"
    width={menuWidth}
    collapsedWidth={menuCollapsedWidth}
    collapsed={collapseMenu}
    collapsible={true}
    onCollapse={onCollapse}
    // className="app-siders bgb"
    style={{overflowY: "auto", height: "100vh"}}
    trigger={null}
    // trigger={<LeftArrowOutlined style={{position: "relative", top: 4, color: "gray"}} />}
  >
    <section className="space space-col space-between" style={{height: "100%"}}>
      <div>
        <div style={{padding: "20px 0 1px 0"}}>
          <a href="/" style={{paddingLeft: 20}}>
            {collapseMenu ?
              <img width={24} src="/icons/icon_sky.png" /> :
              <img width={68} src={"/icons/line-on-dark.png"} />
            }
          </a>
          <Divider className="no-bottom" />
        </div>
    <div style={{padding: "0 5px 0 0"}}>
      <CollectionsTree ready={collectionsLoaded} />
    </div>
      </div>
    {/*<div style={{height: 100}}></div>*/}
    <Menu inlineIndent={0}
      className="transparent-bg bottom-links"
      theme={"dark"}
      onClick={onClick}
      selectedKeys={[current]}
      mode="vertical"
      items={bottomItems}
    />
    </section>
  </Layout.Sider>;
}

export default DashboardMenu;
